import { render, staticRenderFns } from "./ProductOrderEdit.vue?vue&type=template&id=562bc850&scoped=true&"
import script from "./ProductOrderEdit.vue?vue&type=script&lang=js&"
export * from "./ProductOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderEdit.vue?vue&type=style&index=0&id=562bc850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562bc850",
  null
  
)

export default component.exports